<template>
  <div id="user_notice">
    <div class="top_title fixed">{{ active == 1 ? "系统通知" : "站内信" }}</div>
    <van-tabs v-model="active" color="var(--theme)" background="#f2f2f2" @click="onClick">
        <van-tab title="站内信">
        <notice-scroll url="message/index" :params="params" :method="'get'" v-if="active == 0">
          <template slot-scope="scope">
            <div class="goods_list">
              <div class="notice_box" v-for="(row, i) in scope.data" :key="i">

                <div class="nb2" @click="gotoNotice(row.id)">
              <div class="nb_header">
                <div class="left">{{ row.title }}</div>
                <div class="right">
                  <el-button>详情</el-button>
                </div>
              </div>
              <div class="nb_content" v-html="row.content"></div>
              <div class="nb_footer">
                <img class="time" src="../../assets/bx/time.png" alt="" />{{
                  row.ctime.slice(5, 16)
                }}
              </div>
            </div>
              </div>
            </div>
          </template>
        </notice-scroll>
      </van-tab>
      <van-tab title="系统通知">
        <notice-scroll url="notice/index" :params="params" :method="'get'" v-if="active == 1">
          <template slot-scope="scope">
            <div class="goods_list">
              <div class="notice_box" v-for="(row, i) in scope.data" :key="i">
                <div class="nb" @click="gotoDetail(row.order_num, row.otype,row.goods_id)">
                  <div class="nb_header">
                    <div class="left">{{ row.title }}</div>
                    <div class="right">
                      <el-button>详情</el-button>
                    </div>
                  </div>
                  <div class="nb_content" v-if="row.otype == 1">
                    亲爱的玩家，您的<img
                      class="icon"
                      :src="row.goods_img"
                      alt=""
                    /><span class="goods_name">{{ row.goods_name }}</span
                    >已成功<span class="red">售出</span>
                  </div>
                  <div class="nb_content" v-else-if="row.otype == 2">
                    亲爱的玩家，您已成功<span class="success">购买</span
                    ><img class="icon" :src="row.goods_img" alt="" /><span
                      class="goods_name"
                      >{{ row.goods_name }}</span
                    >
                  </div>
                  <div class="nb_content" v-else-if="row.otype == 3">
                    亲爱的玩家，您的<img
                      class="icon"
                      :src="row.goods_img"
                      alt=""
                    /><span class="goods_name">{{ row.goods_name }}</span
                    ><span class="red">审核失败</span>
                  </div>
                  <div class="nb_footer">
                    <img class="time" src="../../assets/bx/time.png" alt="" />{{
                      row.ctime.slice(5, 16)
                    }}
                  </div>
                </div>
                <!-- <div class="nb2" v-else @click="gotoNotice(item.id)">
              <div class="nb_header">
                <div class="left">{{ item.title }}</div>
                <div class="right">
                  <el-button>详情</el-button>
                </div>
              </div>
              <div class="nb_content">{{ item.content }}</div>
              <div class="nb_footer">
                <img class="time" src="../../assets/bx/time.png" alt="" />{{
                  item.ctime.slice(5, 16)
                }}
              </div>
            </div> -->
              </div>
            </div>
          </template>
        </notice-scroll>
      </van-tab>

    </van-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      notice: [],
      active: Number(this.$route.query.active),
      params: {}
    };
  },
  mounted() {
    //this.getNotice()
  },
  methods: {
    getNotice() {
      this.$Ajax("notice/index", {}, "get").then(rs => {
        this.show = true;
        if (rs.code == 200) {
          this.notice = rs.data;
        }
      });
    },
    onClick(name,title) {
        this.active = name
        this.$router.replace({
            name: 'user.notice',
            query: {
                active: name
            }
        })
    },
    gotoDetail(order_num, otype,id) {
      if(otype == 3) {
        this.$router.push({
          name: 'order.detail',
          query: {
              id
          }
        })
      }else {
        this.$router.push({
          name: "goods.detail",
          query: {
            order_num,
            type: otype == 1 ? "buy" : "sell",
          },
        });
      }
    },
    gotoNotice(id) {
      this.$router.push({
        name: "notice.detail",
        query: {
          id,
        },
      });
    },
  },
  watch: {
    '$route.query.active': {
        immediate: true,
        handler(e) {
            this.active = Number(e)
        }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.van-tabs__wrap {
    position: sticky;
    top: 10.8rem;
}
/deep/.van-tab {
  font-size: 1.4rem;
}
.top_title.fixed {
  top: 7.7rem;
}
.no_notice {
  text-align: center;
  margin: 2rem 0;
  color: #aaa;
}

.notice_box {
  background-color: #fff;
  border-radius: 0.6rem;
  padding: 1rem 0.5rem;
  margin-bottom: 1rem;
  width: 100%;
  cursor: pointer;
  .nb_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.5rem 1rem 1.5rem;
    border-bottom: 1px solid #eee;

    .left {
      font-size: 1.5rem;
    }

    .right {
      .el-button {
        width: 7rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f2f2f2;
        font-size: 1.2rem;
        border-radius: 10rem;
      }
    }
  }

  .nb_content {
    padding: 0.9rem 1.5rem;
    font-size: 1.4rem;

    .icon {
      width: 3.6rem;
    }

    .goods_name {
      color: #e6681c;
      margin-right: 0.3rem;
    }

    .red {
      color: var(--red);
    }

    .success {
      color: var(--success);
    }
  }

  .nb_footer {
    padding: 0.5rem 1.5rem 0;
    display: flex;
    align-items: center;
    color: #bbb;

    .time {
      width: 1.85rem;
      height: 1.95rem;
      margin-right: 0.6rem;
    }
  }
}
</style>
